<template>
    <div class="search-result">
        <searchInput
            v-model="keyword"
            @change="changeKeyword"
        />

        <div v-for="(value, index) in companyList" :key="value.id">
            <shopResultComponent :obj="value" @click-go-shop="goShop" />
        </div>

        <div>
            <paginationComponent :pageObj="pageObj" @goPage="goPageNum" />
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, ref, onMounted, toRef, inject} from 'vue'
    import { ElMessage } from 'element-plus'
    import shopResultComponent from '@/components/phone/hall/shopHallResultComponent.vue'
    import searchInput from "@/components/shopopee/form/searchInput"
    import paginationComponent from "@/components/shopopee/common/paginationComponent"
    import {useUserinfo} from "@/stores/userinfo";
    import record15Api from "@/request/record15Api";

    const emits = defineEmits(['go-shop'])
    const props = defineProps([])

    let { proxy } = getCurrentInstance();

    const userInfoRef = toRef(useUserinfo())

    const keyword = ref("")
    const companyList = ref([])
    const loadingFlag = ref(false)

    const i18n = inject("i18n")

    let pageNum = 1
    let pageSize = 10
    let pageObj = ref({})

    function changeKeyword() {
        loadingFlag.value = true
        queryCompanyByPage(queryCompanyCallback)
    }


    async function queryCompanyByPage(callback) {
        const request = record15Api.getRecord15ListandCompanyByPage
        const params = request.getParams()

        params.recordname = keyword.value
        params.updatedid = userInfoRef.value.hid
        params.pageNum = pageNum
        params.pageSize = pageSize

        request.send(params, (res) => {
            loadingFlag.value = false
            callback(res)
        })
    }

    function queryCompanyCallback(detail) {
        if (null != detail && detail.code === 200){
            pageObj.value = detail.detail
            companyList.value = detail.detail.list
        }else{
            companyList.value = []
            pageObj.value = {}

            ElMessage({
                showClose: true,
                message: detail.msg,
                type: 'wanning',
                // appendTo: proxy.$refs.cardview,
                offset: 180
            })
        }
    }

    function goShop(wa, siojournal) {
        emits("go-shop", wa, siojournal)
    }

    function goPageNum(num){
        pageNum = num
        changeKeyword()
    }

    onMounted(() => {
        changeKeyword()
    })
</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .search-box {
        text-align: center;
        width: 80%;
        margin: auto;
        box-sizing: border-box;
        padding: 10px;
        height: 60px;
    }

    .search-result {
        width: 100%;
        height: calc(100% - 110px);
        padding: 10px;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }
</style>